
//全局公用js方法库
import store from "../store.js";
//打开微信聊天  客户微信需要externalUserId  企业微信 需要userId  type:打开类型  0 客户微信  1 企业微信
const OpenWechat=(UserId,type)=>{

    if(type==1)
    {
        wx.openEnterpriseChat({
            userIds: UserId,//参与会话的企业成员列表，格式为userid1;userid2;...，用分号隔开。
            // externalUserIds: '', // 参与会话的外部联系人列表，格式为userId1;userId2;…，用分号隔开。
            groupName: "", // 会话名称。单聊时该参数传入空字符串""即可。
            chatId: "", // 若要打开已有会话，需指定此参数。如果是新建会话，chatId必须为空串
            success: function(res) {
                // console.log("打印微信聊天返回信息",res);
            },
            fail: function(res) {
                if (res.errMsg.indexOf("function not exist") > -1) {
                    alert("版本过低请升级");
                }
            }
        });
    }else
    {
        wx.openEnterpriseChat({

            // userIds: '',//参与会话的企业成员列表，格式为userid1;userid2;...，用分号隔开。
            externalUserIds: UserId, // 参与会话的外部联系人列表，格式为userId1;userId2;…，用分号隔开。
            groupName: "", // 会话名称。单聊时该参数传入空字符串""即可。
            chatId: "", // 若要打开已有会话，需指定此参数。如果是新建会话，chatId必须为空串
            success: function(res) {
                console.log("打印微信聊天返回信息",res);
            },
            fail: function(res) {
                if (res.errMsg.indexOf("function not exist") > -1) {
                    alert("版本过低请升级");
                }
            }
        });
    }

}

//判断小数后面的值是否为0  为0则不显示小数
const RemovedDecimals=(num)=>{

    if(num)
    {
        //拷贝一份 返回去掉零的新串
        let newstr = num;
        //循环变量 小数部分长度
        // console.log(num.indexOf('.') - 1);
        let leng = num.length - num.indexOf('.') - 1;
        //判断是否有效数
        if (num.indexOf('.') > -1) {
            //循环小数部分
            for (let i = leng; i > 0; i--) {
                //如果newstr末尾有0
                if (
                newstr.lastIndexOf('0') > -1 &&
                newstr.substr(newstr.length - 1, 1) == 0
                ) {
                let k = newstr.lastIndexOf('0');
                //如果小数点后只有一个0 去掉小数点
                if (newstr.charAt(k - 1) == '.') {
                    return newstr.substring(0, k - 1);
                } else {
                    //否则 去掉一个0
                    newstr = newstr.substring(0, k);
                }
                } else {
                //如果末尾没有0
                return newstr;
                }
            }
        }
        return num;
    }
    else
    {
        return "0";
    }

}

//判断小数后面的值是否为0  为0则不显示小数
const RemovedDecimalsOne=(num)=>{

    if(num)
    {
        //拷贝一份 返回去掉零的新串
        let newstr = num;
        //循环变量 小数部分长度

        let leng = num.length - num.indexOf('.') - 1;
        //判断是否有效数
        if (num.indexOf('.') > -1) {
        //循环小数部分
            for (let i = leng; i > 0; i--) {
                //如果newstr末尾有0
                if (
                newstr.lastIndexOf('0') > -1 &&
                newstr.substr(newstr.length - 1, 1) == 0
                ) {
                let k = newstr.lastIndexOf('0');
                //如果小数点后只有一个0 去掉小数点
                if (newstr.charAt(k - 1) == '.') {
                    return newstr.substring(0, k - 1);
                } else {
                    //否则 去掉一个0
                    newstr = newstr.substring(0, k);
                }
                } else {
                //如果末尾没有0
                if(leng>3)
                {
                    return newstr.substring(0,4);
                }
                else
                {
                    return newstr;
                }

                }
            }
        }
        return num;
    }
    else
    {
        return "0";
    }
}
//获取进度条百分比
const GetPercentage=(value)=>{
    let result=0;
    if(value)
    {
        if(value<0)
        {
            result=0;
        }
        else if(value>100)
        {
            result=100;
        }
        else
        {
            result=Number(value);
        }
    }

    return result;
}

// //根据生日日期获取年龄
const GetAgesByBirthday=(strBirthday)=> {
    if(strBirthday)
    {
        strBirthday=strBirthday.substring(0,10);//去掉可能的 时分秒

        var returnAge;
        var strBirthdayArr=strBirthday.split("-");
        var birthYear = strBirthdayArr[0];
        var birthMonth = strBirthdayArr[1];
        var birthDay = strBirthdayArr[2];

        let d = new Date();
        var nowYear = d.getFullYear();
        var nowMonth = d.getMonth() + 1;
        var nowDay = d.getDate();

        if(nowYear == birthYear){
            returnAge = 0;//同年 则为0岁
        }
        else{
            var ageDiff = nowYear - birthYear ; //年之差
            if(ageDiff > 0){
                if(nowMonth == birthMonth) {
                    var dayDiff = nowDay - birthDay;//日之差
                    if(dayDiff < 0)
                    {
                        returnAge = ageDiff - 1;
                    }
                    else
                    {
                        returnAge = ageDiff ;
                    }
                }
                else
                {
                    var monthDiff = nowMonth - birthMonth;//月之差
                    if(monthDiff < 0)
                    {
                        returnAge = ageDiff - 1;
                    }
                    else
                    {
                        returnAge = ageDiff ;
                    }
                }
            }
            else
            {
                returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
            }
        }
        return returnAge;//返回周岁年龄
    }
    else
    {
        return "0";
    }
}

// //根据生日日期获取多少年多少月
const GetYearMoutnByBirthday=(strBirthday)=> {

    if(strBirthday)
    {
        strBirthday=strBirthday.substring(0,10);//去掉可能的 时分秒

        var returnYear=0;//年
        var returnMouth=0;//月
        var strBirthdayArr=strBirthday.split("-");
        var birthYear = strBirthdayArr[0];
        var birthMonth = strBirthdayArr[1];
        var birthDay = strBirthdayArr[2];

        let d = new Date();
        var nowYear = d.getFullYear();
        var nowMonth = d.getMonth() + 1;
        var nowDay = d.getDate();

        if(nowYear == birthYear){
            returnYear = 0;//同年 则为0岁
            //判断月份相差 一般不会有添加0岁的孩子 月份相差默认0
            returnMouth=0;
        }
        else
        {
            var ageDiff = nowYear - birthYear ; //年之差
            if(ageDiff > 0)
            {

                returnYear=ageDiff;
                if(nowMonth == birthMonth) {

                    returnMouth=0;
                    var dayDiff = nowDay - birthDay;//日之差
                    if(dayDiff < 0)
                    {
                        returnYear = ageDiff - 1;

                    }
                    else
                    {
                        returnYear = ageDiff ;
                    }

                }
                else
                {
                    var monthDiff = nowMonth - birthMonth;//月之差
                    if(monthDiff < 0)
                    {
                        returnYear = ageDiff - 1;
                        returnMouth=12+monthDiff;
                    }
                    else
                    {
                        returnYear = ageDiff ;
                        returnMouth=monthDiff;
                    }
                }
            }
            else
            {
                returnYear = 0;//返回-1 表示出生日期输入错误 晚于今天
                returnMouth=0;
            }
        }
        return [returnYear,returnMouth];//返回多少年 多少月
    }
    else
    {
        return [0,0];
    }
}
//将时间转换成年月 yyyy年mm月dd
const GetDateYMDStr=(time)=>{
    let dt;
    if (time == '' || time == undefined) {
        dt = new Date();
    }
    else {
        if ((typeof time) == "string") {
            time = time.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
        }
        dt = new Date(time);
    }


    let year = dt.getFullYear();
    let month = dt.getMonth() + 1;
    let day = dt.getDate();
    let hour = dt.getHours();
    let minute = dt.getMinutes();
    let second = dt.getSeconds();
    var monthStr = '';
    var dayStr = '';
    var hourStr = '';
    var minuteStr = '';
    var secondStr = '';

    //月
    if (month < 10) {
        monthStr = '0' + month;
    }
    else {
        monthStr = month;
    }

    //日
    if (day < 10) {
        dayStr = '0' + day;
    }
    else {
        dayStr = day;
    }

    //小时
    if (hour < 10) {
        hourStr = '0' + hour;
    }
    else {
        hourStr = hour;
    }

    //分
    if (minute < 10) {
        minuteStr = '0' + minute;
    }
    else {
        minuteStr = minute;
    }


    //秒
    if (second < 10) {
        secondStr = '0' + second;
    }
    else {
        secondStr = second;
    }

    // return year + '-' + monthStr + '-' + dayStr + ' ' + hourStr + ":" + minuteStr + ":" + secondStr;
    return year + '年' + monthStr + '月' + dayStr+'日';
}

//将时间转换成年月 yyyy年mm月dd
const GetDateYMD=(time)=>{
    let dt;
    if (time == '' || time == undefined) {
        dt = new Date();
    }
    else {
        if ((typeof time) == "string") {
            time = time.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
        }
        dt = new Date(time);
    }


    let year = dt.getFullYear();
    let month = dt.getMonth() + 1;
    let day = dt.getDate();
    let hour = dt.getHours();
    let minute = dt.getMinutes();
    let second = dt.getSeconds();
    var monthStr = '';
    var dayStr = '';
    var hourStr = '';
    var minuteStr = '';
    var secondStr = '';

    //月
    if (month < 10) {
        monthStr = '0' + month;
    }
    else {
        monthStr = month;
    }

    //日
    if (day < 10) {
        dayStr = '0' + day;
    }
    else {
        dayStr = day;
    }

    //小时
    if (hour < 10) {
        hourStr = '0' + hour;
    }
    else {
        hourStr = hour;
    }

    //分
    if (minute < 10) {
        minuteStr = '0' + minute;
    }
    else {
        minuteStr = minute;
    }


    //秒
    if (second < 10) {
        secondStr = '0' + second;
    }
    else {
        secondStr = second;
    }

    // return year + '-' + monthStr + '-' + dayStr + ' ' + hourStr + ":" + minuteStr + ":" + secondStr;
    return year + '-' + monthStr + '-' + dayStr;
}

//将时间转换成月 日  mm月dd
const GetDateMDStr=(time)=>{
    let dt;
    if (time == '' || time == undefined) {
        dt = new Date();
    }
    else {
        if ((typeof time) == "string") {
            time = time.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
        }
        dt = new Date(time);
    }


    let year = dt.getFullYear();
    let month = dt.getMonth() + 1;
    let day = dt.getDate();
    let hour = dt.getHours();
    let minute = dt.getMinutes();
    let second = dt.getSeconds();
    var monthStr = '';
    var dayStr = '';
    var hourStr = '';
    var minuteStr = '';
    var secondStr = '';

    //月
    if (month < 10) {
        monthStr = '0' + month;
    }
    else {
        monthStr = month;
    }

    //日
    if (day < 10) {
        dayStr = '0' + day;
    }
    else {
        dayStr = day;
    }

    //小时
    if (hour < 10) {
        hourStr = '0' + hour;
    }
    else {
        hourStr = hour;
    }

    //分
    if (minute < 10) {
        minuteStr = '0' + minute;
    }
    else {
        minuteStr = minute;
    }


    //秒
    if (second < 10) {
        secondStr = '0' + second;
    }
    else {
        secondStr = second;
    }

    // return year + '-' + monthStr + '-' + dayStr + ' ' + hourStr + ":" + minuteStr + ":" + secondStr;
    return  monthStr + '月' + dayStr+'日';
}

//将时间转换成YYYY-MM-DD hh:mm:ss  
const GetTimeYmdhms=(time)=>{
    let dt;
    if (time == '' || time == undefined) {
        dt = new Date();
    }
    else {
        if ((typeof time) == "string") {
            time = time.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
        }
        dt = new Date(time);
    }


    let year = dt.getFullYear();
    let month = dt.getMonth() + 1;
    let day = dt.getDate();
    let hour = dt.getHours();
    let minute = dt.getMinutes();
    let second = dt.getSeconds();
    var monthStr = '';
    var dayStr = '';
    var hourStr = '';
    var minuteStr = '';
    var secondStr = '';

    //月
    if (month < 10) {
        monthStr = '0' + month;
    }
    else {
        monthStr = month;
    }

    //日
    if (day < 10) {
        dayStr = '0' + day;
    }
    else {
        dayStr = day;
    }

    //小时
    if (hour < 10) {
        hourStr = '0' + hour;
    }
    else {
        hourStr = hour;
    }

    //分
    if (minute < 10) {
        minuteStr = '0' + minute;
    }
    else {
        minuteStr = minute;
    }


    //秒
    if (second < 10) {
        secondStr = '0' + second;
    }
    else {
        secondStr = second;
    }

    return year + '-' + monthStr + '-' + dayStr + ' ' + hourStr + ":" + minuteStr ;

}

//将字符串时间转换成时间对象
const GetDateByYYYYMMDD=(time)=>{
    let dt;
    if (time == '' || time == undefined) {
        dt = new Date();
    }
    else {
        if ((typeof time) == "string") {
            time = time.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
        }
        dt = new Date(time);
    }


    return dt;
}


//将字符串时间转换成时间对象
const GetDateWeekStr=(value)=>{
   let list=[
    {
        title:'周日',
        value:0
    },
    {
        title:'周一',
        value:1
    },
    {
        title:'周二',
        value:2
    },
    {
        title:'周三',
        value:3
    },
    {
        title:'周四',
        value:4
    },
    {
        title:'周五',
        value:5
    },
    {
        title:'周六',
        value:6
    },

   ];
   let result="";
   for(var i=0;i<list.length;i++)
   {
    if(value==list[i].value)
    {
        result=list[i].title;
    }
   }

    return result;
}
//根据年龄推算生日
const GetBirthdayByAge=(year,month)=>{

    let nowDate=new Date();
    let nowYear = nowDate.getFullYear();
    let nowMonth = nowDate.getMonth() + 1;

    let newYear=nowYear-year;
    let newMonth=nowMonth-month;
    if(newMonth<=0)
    {
        newMonth=newMonth+12;
        newYear=newYear-1;
    }

    return newYear + '-' + newMonth + '-' + '1';
};

//计算时间相差天数
const GetDayCount=(date1,date2)=>{
    let dt1,dt2;
    if ((typeof date1) == "string") {
        date1 = date1.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
    }
    dt1= new Date(date1);

    if ((typeof date2) == "string") {
        date2 = date2.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
    }
    dt2= new Date(date2);

    var result = dt1.getTime() - dt2.getTime();
    var dayCount= Math.floor(result / (24 * 3600 * 1000));
    return dayCount;
};

//根据时间差的天数计算新日期  dateTime 要对比的时间  days相差的天数  可以为负数  负数表示相差天数之前的时间  正数表示 相差天数之后的时间
const GetNewDayByCount=(dateTime,days)=>{


    if ((typeof dateTime) == "string") {
        dateTime = dateTime.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
    }
    let nowDate = new Date(dateTime).getTime(); //当前时间戳

    let futureTime =0;


    futureTime = Math.abs(nowDate) + (days * 24 * 60 * 60 * 1000) //days天后的时间戳

	let futureDate = new Date(futureTime);
	let year = futureDate.getFullYear();
	let month = futureDate.getMonth() + 1;
	if (month < 10) month = "0" + month;
	let day = futureDate.getDate();
	if (day < 10) day = "0" + day;
	return (year + "-" + month + "-" + day);
};


//获取当月第一天和最后一天  本月逻辑调整 为当月第一天到今天
const GetCurrentMonthDay=()=>{

    let date = new Date()
    let currentDate=new Date();
    date.setDate(1) // 将当前时间的日期设置成第一天
    let year= date.getFullYear() // 得到当前年份 
    let month = date.getMonth() + 1 // 得到当前月份（0-11月份，+1是当前月份）
    month = month > 10 ? month :'0' + month // 补零
    let day = date.getDate() // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了 
    let fristDay = year +'-'+ month +'-0'+ day // 这里传入的是字符串
    let currentDay=currentDate.getDate();//当前日期

    // 最后一天
    let y = new Date().getFullYear();
    let m = new Date().getMonth()+1;
    let d = new Date(y,m,0).getDate();
    m = m<10?'0'+m:m;
    d = d<10?'0'+d:d;

    currentDay = currentDay<10?'0'+currentDay:currentDay;//补零
    let lastDay= y +'-'+ m +'-'+ d ; 
    let currdntDay=year+'-'+month+'-'+currentDay;
    return [fristDay,currdntDay]; 
};

//获取近三个月的开始和结束时间  many  表示近几个月
const GetCurrentThreeMonth=(many)=>{
    // let many=3;
    let flag='before';
    const thirtyDays = [4, 6, 9, 11] // 30天的月份
    const thirtyOneDays = [1, 3, 5, 7, 8, 10, 12] // 31天的月份
    const currDate = new Date() // 今天日期
    const year = currDate.getFullYear()
    let day=currDate.getDate();
    let nowMonth=currDate.getMonth() + 1;
    let month = currDate.getMonth() + 1
    let targetDateMilli = 0
    let GMTDate = '' // 中国标准时间
    let targetYear = '' // 年
    let targetMonth = '' // 月
    let targetDate = '' // 日
    let dealTargetDays = '' // 目标日期
    const isLeapYear =
      !!((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) // 是否是闰年
    let countDays = 0 // 累计天数
    for (let i = 0; i < many; i++) {
      if (flag === 'before') {
        month = month - 1 <= 0 ? 12 : month - 1
      } else {
        month = month + 1 > 12 ? 1 : month + 1
      }
      thirtyDays.includes(month)
        ? (countDays += 30)
        : thirtyOneDays.includes(month)
          ? (countDays += 31)
          : isLeapYear
            ? (countDays += 29)
            : (countDays += 28)
    }
    targetDateMilli = currDate.setDate(
      currDate.getDate() - (flag === 'before' ? countDays : countDays * -1)
    )
    GMTDate = new Date(targetDateMilli)
    targetYear = GMTDate.getFullYear()
    targetMonth = GMTDate.getMonth() + 2
    // targetDate = GMTDate.getDate()
    targetDate=1;
    targetMonth = targetMonth.toString().padStart(2, '0')
    targetDate = targetDate.toString().padStart(2, '0')
    // dealTargetDays = `${targetYear}-${targetMonth}-${targetDate}`
    dealTargetDays = `${targetYear}-${targetMonth}-${targetDate}`
    nowMonth = nowMonth<10?'0'+nowMonth:nowMonth;
    day = day<10?'0'+day:day;
    let nowDate=`${year}-${nowMonth}-${day}`;


    return [dealTargetDays,nowDate]
};


//获取当前周  根据日期  起始周为周一
const GetCurrentWeek=(date)=>
{
    let dt;
    if (date == '' || date == undefined) {
        dt = new Date();
    }
    else {
        if ((typeof date) == "string") {
            date = date.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
        }
        dt = new Date(date);
    }
    // 设置时间为当天的0点
    dt.setHours(0);
    dt.setMinutes(0);
    dt.setSeconds(0);
    dt.setMilliseconds(0);
    let weeklist=[
        {
            weekName: '周一',
            weekValue: '1',
            dateStr:'',
            date:'',
            day: '',//日期天数
            month:'',//月份
            year:'',//年
            isClass:0,//是否有课
        },
        {
            weekName: '周二',
            weekValue: '2',
            dateStr:'',
            date:'',
            day: '',//日期天数
            month:'',//月份
            year:'',//年
            isClass:0,//是否有课
        },
        {
            weekName: '周三',
            weekValue: '3',
            dateStr:'',
            date:'',
            day: '',//日期天数
            month:'',//月份
            year:'',//年
            isClass:0,//是否有课
        },
        {
            weekName: '周四',
            weekValue: '4',
            dateStr:'',
            date:'',
            day: '',//日期天数
            month:'',//月份
            year:'',//年
            isClass:0,//是否有课
        },
        {
            weekName: '周五',
            weekValue: '5',
            dateStr:'',
            date:'',
            day: '',//日期天数
            month:'',//月份
            year:'',//年
            isClass:0,//是否有课
        },
        {
            weekName: '周六',
            weekValue:'6',
            dateStr:'',
            date:'',
            day: '',//日期天数
            month:'',//月份
            year:'',//年
            isClass:0,//是否有课
        },
        {
            weekName: '周日',
            weekValue: '0',
            dateStr:'',
            date:'',
            day: '',//日期天数
            month:'',//月份
            year:'',//年
            isClass:0,//是否有课
        },
    ];
    let day=dt.getDate();
    let week=dt.getDay();//返回0-6 0表示周日  今天是周几
    week = week == 0 ? 7 : week
    const millisecond=1000*60*60*24;//1天毫秒数

    for(var i=0;i<weeklist.length;i++)
    {
        var minusDay = week-weeklist[i].weekValue;
        if(weeklist[i].weekValue==0)
        {
            minusDay=minusDay-7;//-7 是因为周日是从0开始算 所以要下一周的周日
        }

        var time=new Date(dt.getTime()-minusDay*millisecond);
        var timeYear = time.getFullYear();
        var timeMonth = time.getMonth() + 1;
        if (timeMonth < 10) timeMonth = "0" + timeMonth;
        var timeDay = time.getDate();
        if (timeDay < 10) timeDay = "0" + timeDay;
        var dateStr=timeYear+"-"+timeMonth+"-"+timeDay;
        weeklist[i].date=time;
        weeklist[i].dateStr=dateStr
        weeklist[i].day=time.getDate();
        weeklist[i].month=time.getMonth() + 1;
        weeklist[i].year=timeYear;

    }

    return weeklist;


};

//根据日期获取当前五周数据
const GetCurrentMonth=(date)=>{
    let dt;
    if (date == '' || date == undefined) {
        dt = new Date();
    }
    else {
        if ((typeof date) == "string") {
            date = date.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
        }
        dt = new Date(date);
    }
    // 设置时间为当天的0点
    dt.setHours(0);
    dt.setMinutes(0);
    dt.setSeconds(0);
    dt.setMilliseconds(0);
    let monthlist=[];


    let allweek=GetCurrentAllWeek(dt);
    for(var i=0;i<allweek.length;i++)
    {
        var list=GetCurrentWeek(allweek[i]);
        monthlist.push(list);
    }

    return monthlist;

};

//根据时间差的天数计算新日期  dateTime 要对比的时间  days相差的天数  可以为负数  负数表示相差天数之前的时间  正数表示 相差天数之后的时间
const GetDateByNum=(dateTime,days)=>{


    if ((typeof dateTime) == "string") {
        dateTime = dateTime.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
    }
    let nowDate = new Date(dateTime).getTime(); //当前时间戳

    let futureTime =0;


    futureTime = Math.abs(nowDate) + (days * 24 * 60 * 60 * 1000) //days天后的时间戳

	let futureDate = new Date(futureTime);
	let year = futureDate.getFullYear();
	let month = futureDate.getMonth() + 1;
	if (month < 10) month = "0" + month;
	let day = futureDate.getDate();
	if (day < 10) day = "0" + day;
    return year+'-'+month+'-'+day;
	// return futureDate;
};

// 本月的每一周（从本周一）
const GetCurrentAllWeek=(date)=> {
    // debugger
    let week_array = [];
    let today = new Date(Date.parse(date));
    let year = today.getFullYear();
    let month = today.getMonth();
    let i = 0;

    let start = new Date(year, month, 1); // 得到当月第一天
    let end = new Date(year, month+1, 0); // 得到当月最后一天
    let start_day = start.getDay(); // 当月第一天是周几



    switch(start_day)
    {
        case 0: i = 0; break;
        case 1: i = 1; break;
        case 2: i = 0 - 0; break;
        case 3: i = 0 - 1; break;
        case 4: i = 0 - 2; break;
        case 5: i = 0 - 3; break;
        case 6: i = 0 - 4; break;
    }

    while ( week_array.length<6) {
        var oneWeekDate=new Date(year, month, i);
        var oneWeekYear = oneWeekDate.getFullYear();
        var oneWeekMonth = oneWeekDate.getMonth() + 1;
        if (oneWeekMonth < 10) oneWeekMonth = "0" + oneWeekMonth;
        var oneWeekDay = oneWeekDate.getDate();
        if (oneWeekDay < 10) oneWeekDay = "0" + oneWeekDay;
        var str=oneWeekYear+"-"+oneWeekMonth+"-"+oneWeekDay;
        week_array.push(str)
        i += 7;
    }

    // console.log(week_array);
    return week_array;
};

//根据时间 和相差几个月的初始日期  num可以为负数 负数代表往前推的月份
const GetMonthDateByCount=(dateTime,num)=>{
    // debugger

    if ((typeof dateTime) == "string") {
        dateTime = dateTime.replace(/-/g, "/"); //将-替换成/，避免ie和safari下报错
    }
    let nowDate = new Date(dateTime);

	let year = nowDate.getFullYear();
	let month = nowDate.getMonth() + 1;
    var day = nowDate.getDate();
    // console.log("打印当前月",month);
    if(num<0)
    {
        //上一个月

        if ( month == 1 ) {
            year =year- 1;
            month = '12';
        } else {
            month = month - 1;
            month = (month < 10) ? '0'+month : month;
        }
    }
    else
    {
        //下一个月

        if ( month == 12 ) {
            year =year+ 1;
            month = '01';
        } else {
            month =month + 1;
            month = (month < 10) ? '0'+month : month;
        }

    }
    // console.log("打印转换后的月",month);

    // let newDay='01';
    let newDay= new Date(year, month, 0).getDate(); //获取当月最后一日
    if(day>newDay)
    {
        day=newDay;
    }
    day=(day<10)?'0'+day:day;



    let newDate=new Date(year + "/" + month + "/"+day);
	// console.log("打印转换后的时间",newDate);
	return year + "-" + month + "-"+day;
};


//获取汉字1-10的数字 孩子添加的标题使用
const GetNumCapital=(index)=>{
    let result='';
    if(index==1)
    {
        result="一";
    }
    if(index==2)
    {
        result="二";
    }
    if(index==3)
    {
        result="三";
    }
    if(index==4)
    {
        result="四";
    }
    if(index==5)
    {
        result="五";
    }
    if(index==6)
    {
        result="六";
    }
    if(index==7)
    {
        result="七";
    }
    if(index==8)
    {
        result="八";
    }
    if(index==9)
    {
        result="九";
    }
    if(index==10)
    {
        result="十";
    }
    return result;
};
//时间段数组合并
const GetMergeTimeList=(list)=>{
    console.log("打印需要合并的数组",list);
    //先判断同一天的 时间段连续的合并
    let weeklist=[
        {
            week:'0',
            weekName:'周日',
            list:[],
            title:'周日',
        },
        {
            week:'1',
            weekName:'周一',
            list:[],

        },
        {
            week:'2',
            weekName:'周二',
            list:[]
        },
        {
            week:'3',
            weekName:'周三',
            list:[]
        },
        {
            week:'4',
            weekName:'周四',
            list:[]
        },
        {
            week:'5',
            weekName:'周五',
            list:[]
        },
        {
            week:'6',
            weekName:'周六',
            list:[]
        },
    ];

    for(var i=0;i<list.length;i++)
    {
        //周日
        if(list[i].weekValue=='0')
        {
            weeklist[0].list.push(list[i]);
        }
        //周一
        if(list[i].weekValue=='1')
        {
            weeklist[1].list.push(list[i]);
        }
        //周二
        if(list[i].weekValue=='2')
        {
            weeklist[2].list.push(list[i]);
        }
        //周三
        if(list[i].weekValue=='3')
        {
            weeklist[3].list.push(list[i]);
        }
        //周四
        if(list[i].weekValue=='4')
        {
            weeklist[4].list.push(list[i]);
        }
        //周五
        if(list[i].weekValue=='5')
        {
            weeklist[5].list.push(list[i]);
        }
        //周六
        if(list[i].weekValue=='6')
        {
            weeklist[6].list.push(list[i]);
        }
    }
    // console.log("打印",weeklist);
    for(var i=0;i<weeklist.length;i++)
    {
        weeklist[i].list=MergeList(weeklist[i].list);//判断是否连续  连续的话合并成一个
        // if(weeklist[i].list.length==0)
        // {
        //     weeklist.splice(i,1);
        // }
    }
    
    weeklist=MergeWeekList(weeklist);
    console.log("打印合并后的数组",weeklist);
    return weeklist;

};
//判断是否连续  连续的话合并成一个
const MergeList=(list)=>{
    // console.log("进入合并数组",list);
    let newlist=[];
    for(var i=0;i<list.length;i++)
    {
        for(var j=0;j<list.length;j++)
        {
            if(list[i].end==list[j].start)
            {
                // console.log("连续的",list[i],list[j]);
                list[i].end=list[j].end;
                list.splice(j,1);
                list=MergeList(list);
            }
        }
    }
    // console.log("打印合并后的list",list);
    return list;
};
//合并周几 相同的合并
const MergeWeekList=(list)=>{
    console.log("进入相同周合并",list);
    
    
   
    for(var i=0;i<list.length;i++)
    {
        for(var j=0;j<list.length;j++)
        {
            if(i!=j)
            {
                if(list[i].list.length==list[j].list.length)
                {
                    
                        //判断时间是否相同
                        let str1=GetListHourStr(list[i].list);
                        let str2=GetListHourStr(list[j].list);
                        console.log("打印str1",str1);
                        console.log("打印str2",str2);
                        if(str1==str2)
                        {
                            //周 时间段相同 合并到一个
                            // list.splice(i,1);
                            list[j].weekName=list[i].weekName+'、'+list[j].weekName;
                        
                            list.splice(i,1);
                            list=MergeWeekList(list);
                        }
                    
                    
                }
            }
            
        }
    }
    console.log("打印合并后的list",list);
    return list;
};

const GetNumberList=(arr)=>{
    var result = [],
        temp = [];

    arr.sort(function(source, dest){
        return source - dest;
    }).concat(Infinity).reduce(function(source, dest){

        temp.push(source);

        if(dest-source>1){
            result.push(temp);
            temp = [];
        }

        return dest;
    });

    return result;
};

const GetListHourStr=(list)=>{

    let result="";
    for(var i=0;i<list.length;i++)
    {
        if(result=='')
        {
            result=list[i].start+'-'+list[i].end;
        }
        else
        {
            result=result+','+list[i].start+'-'+list[i].end;
        }
    }
    return result;
};

//获取字典对应的key值
const GetTagKey=(name)=>{
    let resultKey="";
    if(name=='距离')
    {
        resultKey='distanceTag';
    }
    else if(name=='意向')
    {
        resultKey='planTag';
    }
    else if(name=='需求')
    {
        resultKey='needTag';
    }
    else if(name=='阶段')
    {
        resultKey='stage';
    }
    else if(name=='来源')
    {
        resultKey='customerSource';
    }
    else if(name=='消费金额')
    {
        resultKey='consumptionAmontTag';
    }
    else if(name=='学员状态')
    {
        resultKey='studentStatus';
    }
    else if(name=='剩余天数')
    {
        resultKey='remainTimeTag';
    }
    else if(name=='剩余课时')
    {
        resultKey='remainAssetsTag';
    }
    else if(name=='上次沟通时间')
    {
        resultKey="lastCommunityTime";
    }
    else if(name=='创建方式')
    {
        resultKey="customerDataSourse";
    }
    return resultKey;
};

const RemovedInteger = (num) => {
    if (num == '0.00') {
        return 0
    }
    if (num) {
        const newNum = Math.floor(num * 1);
        return newNum
    }
    return 0
}
// 2022-01-09 转为 时间戳格式
const TimeStamp = (timeStr) => {
    const newTimeStr = timeStr.split('-').join('/');
    return new Date(newTimeStr).getTime()
}

//获取客户菜单下相关的权限
const getCustomerPermission=(code,childCode)=>{
    let result=false;
    try {
        let list=store.state.userMenu[0].menuList;
        // console.log("打印底部菜单",list)
        let CustomerMenuList=[];
        for(let i=0;i<list.length;i++)
        {
            if(list[i].menuName=='客户')
            {
                CustomerMenuList=list[i].children;
            }
        }
        

        // console.log("打印CustomerMenuList",CustomerMenuList);
        // console.log("打印code，childCode",code,childCode);
        let customerOjb=CustomerMenuList.find(item => item.methodUrl === code);
        // console.log("customerOjb",customerOjb);
        if(customerOjb)
        {
            if(childCode)
            {
                let childMenuList=customerOjb.children;
                
                let childObj=childMenuList.find(item => item.methodUrl === childCode);
                if(childObj)
                {
                    result=true;
                }
                else
                {
                    result=false;
                }
            }
            else
            {
                //查当前级
                if(customerOjb)
                {
                    result=true;
                }
                else
                {
                    result=false;
                }
            }
        }
    } catch (error) {
        
    }
    return result;
}

//获取快捷服务菜单下相关的权限
const getQuickServicePermission=(code,childCode,towChildCode,threeChildCode)=>{
    let result=false;
    try {
        let quickServiceMenu=store.state.userMenu.find(item=>item.group === 'quickService');
        console.log("打印菜单",store.state.userMenu);
        let list=quickServiceMenu.menuList;
        console.log("打印快捷服务菜单",list)
        
        let menuObj=list.find(item => item.methodUrl === code);

        if(childCode)
        {
            let childMenuList=menuObj.children || [];
            let childObj=childMenuList.find(item => item.methodUrl === childCode);
            if(childObj)
            {
                // result=true;
                console.log("打印childObj",childObj);
                if(towChildCode)
                {
                    //进入三级菜单
                    // console.log("四级菜单权限判断",towChildCode);
                    let twochildMenuList=childObj.children || [];
                    let twoChildObj=twochildMenuList.find(item=> item.methodUrl ===towChildCode)
                    if(twoChildObj)
                    {
                        // result=true;
                        if(threeChildCode)
                        {
                            let threechildMenuList=twoChildObj.children || [];
                            let threechildObj=threechildMenuList.find(item=>item.methodUrl===threeChildCode)
                            if(threechildObj)
                            {
                                result=true;
                            }
                            else
                            {
                                result=false;
                            }
                        }
                        else
                        {
                            result=true;
                        }
                    }
                    else
                    {
                        result=false
                    }
                }
                else
                {
                    result=true;
                }
            }
            else
            {
                result=false;
            }
        }
        else
        {
            //查当前级
            if(menuObj)
            {
                result=true;
            }
            else
            {
                result=false;
            }
        }

    } catch (error) {
            
    }
    

    return result;

}

//获取场地管理菜单下相关的权限
const getSpaceManagePermission=(code,childCode)=>{
    let result=false;
    try {
        let menu=store.state.userMenu.find(item=>item.group === 'classroomManage');
        let list=menu.menuList;
        // console.log("打印场地管理菜单",list)
        
        let menuObj=list.find(item => item.methodUrl === code);

        if(childCode)
        {
            let childMenuList=menuObj.children;
            let childObj=childMenuList.find(item => item.methodUrl === childCode);
            if(childObj)
            {
                result=true;
            }
            else
            {
                result=false;
            }
        }
        else
        {
            //查当前级
            if(customerOjb)
            {
                result=true;
            }
            else
            {
                result=false;
            }
        }
    } catch (error) {
        
    }
    

    return result;

}

//通用获取菜单下相关的权限
const getPermission=(group,code,childCode,towChildCode)=>{
    let result=false;
    try {
        // console.log("打印通用管理菜单",store.state.userMenu)
        let menu=store.state.userMenu.find(item=>item.group === group);
        let list=menu.menuList || [];
        let menuObj=list.find(item => item.methodUrl === code);

        if(childCode)
        {
            let childMenuList=menuObj.children || [];
            let childObj=childMenuList.find(item => item.methodUrl === childCode);
            if(childObj)
            {
                // result=true;
                // console.log("打印childObj",childObj);
                if(towChildCode)
                {
                    //进入四级菜单
                    // console.log("四级菜单权限判断",towChildCode);
                    let twochildMenuList=childObj.children || [];
                    let twoChildObj=twochildMenuList.find(item=> item.methodUrl ===towChildCode)
                    if(twoChildObj)
                    {
                        result=true;
                    }
                    else
                    {
                        result=false
                    }
                }
                else
                {
                    result=true;
                }
            }
            else
            {
                result=false;
            }
        }
        else
        {
            //查当前级
            if(customerOjb)
            {
                result=true;
            }
            else
            {
                result=false;
            }
        }
    } catch (error) {
        
    }
    

    return result;

}


//获取字符串后num位 例如 名字后两位
const getStringName=(value,num)=>{
    let result="";
    if(value)
    {
        let nameLength=value.length;
        if(nameLength>num)
        {
            result= value.substring(nameLength-num,nameLength);
        }
        else
        {
            result=value;
        }
    }
    return result;   
}

//周日期格式处理
const GetWeekName=(name)=>
{
            // console.log("打印周几",name);
            let list=name.split("、");
            // console.log(list);
            let newlist=[];
            for(var i=0;i<list.length;i++)
            {
            //   console.log(list[i])
              let n=GetWeekValue(list[i]);
            //   console.log(n);
              newlist.push(n);
            }


            var result = GetNumberList(newlist);
            // console.log(result);
            let newName="";
            for(var i=0;i<result.length;i++)
            {

              let w=result[i];
            //   console.log("打印w",w);
              if(result[i].length>1)
              {
                if(newName=="")
                {
                  newName=GetWeekValueName(result[0][0])+'至'+GetWeekValueName(result[0][result[i].length-1]);
                }
                else
                {
                  newName=newName+","+GetWeekValueName(result[i][0])+'至'+GetWeekValueName(result[i][result[i].length-1]);
                }
              }
              else
              {
                if(newName=='')
                {
                  newName=GetWeekValueName(result[i][0]);
                }
                else
                {
                  newName=newName+','+GetWeekValueName(result[i][0]);
                }

              }


            }


            return newName;
}

const GetWeekValue=(name)=>
{
            // console.log(name);
            let value=1;
            if(name=='周一')
            {
              value=1;
            }
            else if(name=='周二')
            {
              value=2;
            }
            else if(name=='周三')
            {
              value=3;
            }
            else if(name=='周四')
            {
              value=4;
            }
            else if(name=='周五')
            {
              value=5;
            }
            else if(name=='周六')
            {
              value=6;
            }
            else if(name=='周日')
            {
              value=7;
            }

            return value;
}

const GetWeekValueName=(value)=>
{
            // console.log(value);
            let name='';
            if(value==1)
            {
              name="周一";
            }
            else if(value==2)
            {
              name="周二";
            }
            else if(value==3)
            {
              name="周三";
            }
            else if(value==4)
            {
              name="周四";
            }
            else if(value==5)
            {
              name="周五";
            }
            else if(value==6)
            {
              name="周六";
            }
            else if(value==7)
            {
              name="周日";
            }

            return name;
}


export default {
    OpenWechat,//公开微信聊天
    RemovedDecimals,
    RemovedDecimalsOne,//保留一位小数
    GetPercentage,
    GetAgesByBirthday,
    GetYearMoutnByBirthday,//将生日转换成年和月
    GetDateYMD,//时间转换成yyyy-mm-dd
    GetDateYMDStr,//时间转换成yyyy年mm月dd日
    GetDateMDStr,//时间转换成mm月dd日
    GetBirthdayByAge,
    GetDayCount,
    GetNewDayByCount,
    GetCurrentWeek,//获取当前周数组
    GetDateByNum,//获取几天后或者几天前的时间
    GetCurrentMonth,//获取当前月份所有日期
    GetCurrentAllWeek,
    GetMonthDateByCount,//获取上个月1号或者下个月1号
    GetDateByYYYYMMDD,
    GetTimeYmdhms,//精确到时分秒
    GetDateWeekStr,
    GetTagKey,
    GetNumCapital,
    RemovedInteger,
    GetMergeTimeList,
    TimeStamp,
    GetNumberList,
    getCustomerPermission,//获取客户相关的菜单权限
    getQuickServicePermission,//获取快捷服务相关的菜单
    getSpaceManagePermission,//获取场地管理菜单下相关权限
    getPermission,//获取通用菜单权限
    getStringName,//获取字符串后num位 例如 名字后两位
    GetWeekName,//周一、周二 、周三 、周四  等等 合并成 周一至周四
    GetCurrentMonthDay,//获取本月开始时间和结束时间
    GetCurrentThreeMonth,//获取近三个月的开始时间和结束时间

}



// WEBPACK FOOTER //
// ./src/util/global.js